import { useTranslation } from 'react-i18next'

import { Badge } from '@/Atomic/Atoms/Badge'
import { formatDuration } from '@/utils/timerecordUtils'

interface TimeTrackingTotalsProps {
  totals: {
    billableDuration: number
    nonBillable: number
  }
}

export const TimeTrackingTotals = ({ totals }: TimeTrackingTotalsProps) => {
  const { t } = useTranslation()
  return (
    <div className="time-tracking-totals">
      <span className="text-muted">{t('timeTracking.columns.total')}</span>
      <div className="time-tracking-totals-item">
        <Badge
          variant="success"
          value={t('timeTracking.columns.billableUpper')}
        />
        <span className="time-tracking-totals-value">
          {formatDuration(totals.billableDuration)}
        </span>
      </div>
      <div className="time-tracking-totals-item">
        <Badge
          variant="warning"
          value={t('timeTracking.columns.nonBillableUpper')}
        />
        <span className="time-tracking-totals-value">
          {formatDuration(totals.nonBillable)}
        </span>
      </div>
    </div>
  )
}
